export const EmailRenderer = (col) => (rowData) => {
    const email = rowData?.[col.field];
    if (!email) return "-";

    return (
        <a href={`mailto:${email}`} className="grid-link grid-email">
            {email}
        </a>
    );
};